export default __webpack_public_path__ + "static/media/ZZ_gold.4a1ccf3d.webp";